import { EvmHTLCPublicClient } from './PublicClient.js';
import { userLock } from './wallet/userLock.js';
import { refund } from './wallet/refund.js';
import { redeemSolver } from './wallet/redeemSolver.js';
export class EvmHTLCWalletClient extends EvmHTLCPublicClient {
    constructor(config) {
        super(config);
        this.signer = config.signer;
    }
    async userLock(params) {
        return userLock(this.rpc, this.signer, params);
    }
    async refund(params) {
        return refund(this.rpc, this.signer, params);
    }
    async redeemSolver(params) {
        return redeemSolver(this.rpc, this.signer, params);
    }
}
